import React from "react";

// Components
import TextInput from "components/input/TextInput";
import SelectInput from "components/input/SelectInput";
import PhoneNumberInput from "components/special-input/PhoneNumberInput";

function BasicInfoForm({
  coursesOptions,
  values,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  handleChange,
  handleBlur,
  handleSelectedProgram,
  handleSubmit,
}) {
  return (
    <div className="bg-gray-100 rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6">
      <p className="uppercase text-lg sm:text-xl xl:text-2xl xl:text-2xl mb-2 md:mb-4 font-bold">
        Basic Information
      </p>
      <TextInput
        name="full_name"
        label="Full Name"
        required={true}
        placeholder="Fill in your full name..."
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors?.full_name && touched?.full_name && errors.full_name}
        value={values.full_name}
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <TextInput
          name="email_address"
          label="Email Address"
          required={true}
          placeholder="Fill in your email address..."
          onChange={handleChange}
          onBlur={handleBlur}
          error={
            errors?.email_address &&
            touched?.email_address &&
            errors.email_address
          }
          value={values.email_address}
          capitalize={false}
        />
        <PhoneNumberInput
          inputName="phone_number"
          selectName="phone_code"
          label="Phone Number"
          required={true}
          placeholderInput="Fill in your phone number..."
          onChangeInput={handleChange}
          onBlurInput={handleBlur}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          errorInput={
            errors?.phone_number && touched?.phone_number && errors.phone_number
          }
          errorSelect={
            errors?.phone_code && touched?.phone_code && errors.phone_code
          }
          inputValue={values.phone_number}
          selectValue={values.phone_code}
        />
        <TextInput
          name="company_name"
          label="Company / Organization"
          placeholder="Fill in your company or organization name..."
          onChange={handleChange}
          onBlur={handleBlur}
          error={
            errors?.company_name && touched?.company_name && errors.company_name
          }
          value={values.company_name}
        />
        <TextInput
          name="job_title"
          label="Job Title / Position"
          placeholder="Fill in your job title or position..."
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors?.job_title && touched?.job_title && errors.job_title}
          value={values.job_title}
        />
      </div>
      <p className="uppercase text-lg sm:text-xl xl:text-2xl xl:text-2xl mb-2 md:mb-4 font-bold">
        SELECT PROGRAM
      </p>
      <SelectInput
        name="course_id"
        classNameInput="text-base md:text-lg lg:text-xl"
        label="Which program are you interested in?"
        required={true}
        options={coursesOptions}
        onChange={handleSelectedProgram}
        onBlur={handleBlur}
        error={errors?.course_id && touched?.course_id && errors.course_id}
        value={values.course_id}
      />
      <button
        className="uppercase tracking-widest bg-black text-white w-full p-2 rounded-xl text-lg xl:text-2xl font-semibold disabled:opacity-30"
        onClick={handleSubmit}
        disabled={
          !values.full_name ||
          values.full_name === "" ||
          !values.email_address ||
          values.email_address === "" ||
          errors.email_address ||
          !values.phone_number ||
          values.phone_number === "" ||
          errors.phone_number ||
          !values.phone_code ||
          values.phone_code === "" ||
          errors.phone_code ||
          !values.course_id ||
          values.course_id === ""
        }
      >
        Continue
      </button>
    </div>
  );
}

export default BasicInfoForm;
